import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import {
  ICreateDownloadPayoutsQueue,
  ICreateManualPayout,
  ICreateManualPayoutBank,
} from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";
import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";

export function useCreateDownloadPayoutsQueue() {
  const {
    mutate: createDownloadPayoutsQueue,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreateDownloadPayoutsQueue>({
    mutationFn: async (request) => {
      return await CampaignService.createDownloadPayoutsQueue(request).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    onSuccess: (c) => {
      ToastService.success("Added to Download Queue");
      c.invalidateQueries({
        queryKey: [...DOWNLOADS_LIST_QUERY_KEY],
      });
    },
    options: {},
  });

  return {
    createDownloadPayoutsQueue,
    isCreating,
    isCreated,
  };
}
